type DurationParts = { hours: number; minutes: number; seconds: number; milliseconds: number };

const toParts = (valueMs: number): DurationParts => {
  const totalMs = Math.max(0, Math.floor(valueMs));
  const hours = Math.floor(totalMs / 3600000);
  const minutes = Math.floor((totalMs % 3600000) / 60000);
  const seconds = Math.floor((totalMs % 60000) / 1000);
  const milliseconds = totalMs % 1000;
  return { hours, minutes, seconds, milliseconds };
};

export const formatDuration = (valueMs: number | null | undefined): string => {
  if (valueMs === null || valueMs === undefined) return '';
  const { hours, minutes, seconds, milliseconds } = toParts(valueMs);

  const parts: string[] = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0) parts.push(`${seconds}s`);
  if (milliseconds > 0) parts.push(`${milliseconds}ms`);

  if (parts.length === 0) return '0ms';
  return parts.slice(0, 2).join(' ');
};
